import { Divider, Paper, Portal, Skeleton, styled } from "@mui/material";
import { StyledLinearProgress } from "components/loader/StyledLinearProgress";
import { PaddedPaper } from "components/surfaces/PaddedPaper";

interface Props {
  footerRef: HTMLDivElement;
  mapOverlayContainer: HTMLDivElement;
}

export function MeasureSelectPageSkeleton(props: Props) {
  const { footerRef, mapOverlayContainer } = props;
  const numItems = new Array(10).fill(1);

  return (
    <StyledPaddedPaper padding={3}>
      <Skeleton height={60} />
      <Divider />
      <Paper className="grid" elevation={0}>
        {numItems.map((item, i) => (
          <Skeleton key={i} height={150} width={200} />
        ))}
      </Paper>
      <Portal container={footerRef}>
        <StyledPaper className="footer" elevation={0}>
          <Skeleton width={100} height={40} />
          <Skeleton width={100} height={40} />
        </StyledPaper>
      </Portal>
      <Portal container={mapOverlayContainer}>
        <StyledLinearProgress />
      </Portal>
    </StyledPaddedPaper>
  );
}

const StyledPaddedPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(2)};

  .grid {
    display: grid;
    height: 100%;
    gap: ${({ theme }) => theme.spacing(1)};
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-template-rows: repeat(auto-fill, 150px);
  }
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
`;

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  .MuiSkeleton-root {
    transform: unset;
    transform-origin: unset;
  }
`;
